import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
/** Adresse du projet Supabase (sert à reconnaître les fichiers de son espace de stockage). */
export const supabaseUrl = url;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/**
 * Client Supabase public (clé « anon », publique par conception : les droits sont imposés par RLS).
 * `null` tant que le projet n'est pas configuré : l'interface l'indique au lieu d'afficher des données factices.
 */
/**
 * Lien « mot de passe oublié » ouvert : lu avant la création du client, qui retire ensuite
 * ces paramètres de l'adresse (l'événement PASSWORD_RECOVERY peut partir avant l'abonnement).
 */
export const openedFromRecoveryLink =
  typeof window !== "undefined" && new URLSearchParams(window.location.hash.slice(1)).get("type") === "recovery";

export const supabase: SupabaseClient | null =
  url && anonKey ? createClient(url, anonKey, { auth: { persistSession: true, autoRefreshToken: true } }) : null;

export const isConfigured = supabase !== null;

export class NotConfiguredError extends Error {
  constructor() {
    super("Base de données non configurée");
    this.name = "NotConfiguredError";
  }
}

export function db(): SupabaseClient {
  if (!supabase) throw new NotConfiguredError();
  return supabase;
}
